<template>
<div class="swiper-slide-inner">
    <div class="step">
        <p>価格評価判定 STEP<span>02</span></p>
    </div>
    <div class="card">
        <div class="card-inner">

            <div class="question-wrap">
                <h3><span>取り扱い商品種類を登録</span></h3>
                <p>価格評価判定に使用する商品を3つまで選択してください。</p>
            </div>

            <!--item-->
            <div class="form_checkbox-wrap _small">

                <div class="item form_checkbox" v-for="(categoriyLv2,index) in categoriyLv2List" v-bind:key="index">
                    <input type="checkbox" name="categoriyLv2-checkbox" class="" :id="'categoriyLv2-checkbox' + index" value="" v-on:change="changeLv2(categoriyLv2)">
                    <label :for="'categoriyLv2-checkbox' + index">
                        <div class="check-mark"><span></span></div>
                        <span>{{ categoriyLv2.name }}</span>
                    </label>
                </div>

            </div><!--/.item-wrap-->
        </div>

        <div class="control-wrap">
            <button type="button" class="_left js-swiper-prev" v-on:click="swiperBack2()"><span>Back</span></button>
            <button type="button" class="_right js-swiper-next" v-bind:disabled="isDisabled"><span>Next</span></button>
        </div>

    </div>
</div>
</template>


<script>
    export default {
        data() {
            return {
                categoriyLv2s: [],
                isDisabled: false,
            }
        },
        computed: {
            categoriyLv2List (){
                if (this.$store.state.register.form.select_priceZone_categoriyLv1) {
                    if (this.$store.state.register.form.select_priceZone_categoriyLv1.id == 1) {

                        // その他
                        var Lv3s = [];
                        for(var i in this.$store.state.register.form.Lv3) {
                            var Lv3 = this.$store.state.register.form.Lv3[i];
                            // if (Lv3.name !== 'その他') {
                            //     Lv3s.push(Lv3)
                            // }
                                Lv3s.push(Lv3)
                        }

                        for(var i in this.$store.state.register.form.Lv2) {
                            var Lv2 = this.$store.state.register.form.Lv2[i];
                            if (Lv2.name == 'その他' && Lv2.first_category_id == 1) {
                                Lv3s.push(Lv2)
                            }
                        }

                        // 重複をなくす
                        const uniqueLv3 = Array.from(
                            new Map(Lv3s.map((Lv3) => [Lv3.name, Lv3])).values()
                        );

                        return uniqueLv3;
                    } else {
                        var items = [];
    
                        for(var i in this.$store.state.register.form.Lv2) {
                            var Lv2 = this.$store.state.register.form.Lv2[i];
                            if (this.$store.state.register.form.select_priceZone_categoriyLv1.id == Lv2.first_category_id) {
                                items.push(Lv2)
                            }
                        }

                        // items = items.filter((item) => {
                        //     return (item.name !== 'その他');
                        // });
                        return items;
                    }
                }
            }
        },
        mounted() {
            this.isDisabled = true;
        },
        methods: {
            changeLv2 (categoriyLv2) {


                var $count = $("input[name=categoriyLv2-checkbox]:checked").length;
                var $not = $('input[name=categoriyLv2-checkbox]').not(':checked')

                //チェックが3つ付いたら、チェックされてないチェックボックスにdisabledを加える
                if($count >= 3) {
                    $not.attr("disabled",true);
                }else{
                    //3つ以下ならisabledを外す
                    $not.attr("disabled",false);
                }

                var itemIndex = '';
                var itemCheck = true;

                this.categoriyLv2s.forEach(function(item, index){
                    if (item.name == categoriyLv2.name) {
                        itemIndex = index;
                        itemCheck = false;
                    }
                });

                if (!itemCheck){
                    this.categoriyLv2s.splice(itemIndex, 1)
                } else {
                    this.categoriyLv2s.push(categoriyLv2)
                }

                this.$store.state.register.form.select_priceZone_categoriyLv2 = this.categoriyLv2s;

                if($count == 0) {
                    this.isDisabled = true;
                } else {
                    this.isDisabled = false;
                }
            },
            swiperBack2() {
                var name = 'input[name=categoriyLv2-checkbox]';
                $(name).prop('checked', false);
                this.categoriyLv2s = [];
                this.$store.state.register.form.select_priceZone_categoriyLv2 = [];
                this.isDisabled = true;
            }
        }
    }
</script>